import { Dao } from './dao';
import { HttpService } from 'src/app/core/http/http.service';
import { Path } from 'src/app/core/http/http-config';
import { BehaviorSubject, PartialObserver, Subscription } from 'rxjs';

export class HttpDao<T, ID> implements Dao<T, ID> {

    protected subject: BehaviorSubject<any> = new BehaviorSubject(null);

    constructor(
        protected httpService: HttpService,
        protected path: Path
    ) { }

    setPath(path:Path){
        this.path = path;
    }
    create(obj: T): Promise<ID> {
        return this.httpService.post<ID>(this.path, obj);
    }

    retrive(id: ID): Promise<T> {
        return this.httpService.get<T>(this.path, id);
    }

    update(obj: T): Promise<any> {
        return this.httpService.put<any>(this.path, obj);
    }

    delete(id: ID): Promise<any> {
        return this.httpService.del<any>(this.path, id);
    }

    subscribe(observer?: PartialObserver<any>): Subscription {
        return this.subject.subscribe(observer);
    }
}